import styled from "styled-components";
export const Header = styled.header `
  background: white;
  border-bottom: 2px solid var(--ant-primary-color);
  padding: 0px;

  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
`;
export const HeaderRow = styled.div `
  line-height: var(--opendash-header-row-height);
  height: var(--opendash-header-row-height);
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
    height: calc(var(--opendash-header-row-height) + 1px);
  }
`;
// export const HeaderDropdown = styled.div<{ right: boolean }>`
//   display: block;
//   padding: 1px;
//   background: #005493;
//   box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
//   top: -6px;
//   position: relative;
//   min-width: 302px;
//   /* margin-left: -10px; */
//   ::before {
//     width: 0;
//     height: 0;
//     border-left: 5px solid transparent;
//     border-right: 5px solid transparent;
//     border-bottom: 5px solid #005493;
//     content: "";
//     position: absolute;
//     top: -5px;
//     left: ${(p) => (p.right ? "auto" : "18px")};
//     right: ${(p) => (p.right ? "18px" : "auto")};
//   }
// `;
// export const HeaderDropdownText = styled.div`
//   padding: 10px;
//   color: #fff;
// `;
// export const HeaderDropdownButton = styled.button`
//   color: #fff;
//   background: #0063ac;
//   display: block;
//   line-height: 40px;
//   min-width: 300px;
//   padding: 0 10px;
//   border: 0;
//   border-bottom: 1px solid #005493;
//   text-align: left;
//   :first {
//     border-top: 1px solid #005493;
//   }
//   :hover {
//     color: #fff;
//     background: #005493;
//   }
//   .anticon {
//     margin-right: 10px;
//   }
// `;
export const Layout = styled.section `
  display: flex;
  flex: auto;
  flex-direction: column;
  background: #f0f2f5;

  width: 100%;
  min-height: 100vh;
  padding-top: var(--opendash-header-height);
`;
export const Content = styled.main `
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex: auto;
  min-height: 0;
`;
export const Footer = styled.footer `
  flex: 0 0 auto;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 0px;
`;
export const FooterRowCopyright = styled.div `
  text-align: center;

  height: 40px;
  line-height: 40px;

  > *,
  > a {
    font-size: 12px;
    color: darkgrey;
  }
`;
//# sourceMappingURL=data:application/json;base64,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